import { render, staticRenderFns } from "./StatisticHrFeedExportTableDetail.vue?vue&type=template&id=be470644"
import script from "./StatisticHrFeedExportTableDetail.vue?vue&type=script&lang=js"
export * from "./StatisticHrFeedExportTableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports